<template>
  <b-card header-tag="header" class="m-3" no-body>
    <template #header>
      <header-sagres titulo="Inativar Contas Bancárias" breakpoint="xl" />
    </template>
    <b-card-body>
      <b-col lg="6" class="filtro-pesquisa float-right">
        <b-form-group
          label-for="filter-input"
          label-align-sm="right"
          label-size="sm"
          class="mb-3"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              class="search-input"
              placeholder="Pesquisar"
            />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"
                >Limpar</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-table
        id="contasInativarTable"
        :fields="fields"
        :items="items"
        :busy="tableBusy"
        :current-page="currentPage"
        :filter="filter"
        hover
        no-border-collapse
        sort-by=""
        :sort-desc="true"
        striped
        stacked="xl"
        show-empty
        per-page="10"
        @filtered="onFiltered"
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle" />
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(flInativo)="row">
          <b-badge :variant="row.item.flInativo === 'S' ? 'danger' : 'success'">
            {{ row.item.flInativo === "S" ? "Inativa" : "Ativa" }}
          </b-badge>
        </template>
        <template v-slot:cell(actions)="row">
          <div
            class="actions-icons lgvert d-none d-md-flex justify-content-center"
          >
            <b-link
              v-if="row.item.flInativo === 'N'"
              class="text-danger"
              @click="confirmarInativacao(row.item)"
            >
              <font-awesome-icon icon="ban" />
              <div style="font-size: 12px">Inativar</div>
            </b-link>
            <div v-else class="text-muted" style="font-size: 12px">
              Para reativar, entre em contato com o TCE-SE
            </div>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="10"
        aria-controls="contasInativarTable"
      />
    </b-card-body>
  </b-card>
</template>

<script lang="ts">
import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import { store } from "@/store";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import pcmService from "@/services/entregas/pcmService";
import { ContasInativar } from "@/types/entregas/pcm/conta-inativar";
import { fieldsContasInativar } from "@/types/entregas/pcm/fields-conta-inativar";

const CompProps = Vue.extend({
  name: "ContasInativar",
  components: {
    HeaderSagres,
  },
});

@Component
export default class ContasInativarView extends mixins(UtilsTS, CompProps) {
  fields: TableField[] = fieldsContasInativar;

  items: ContasInativar[] = [];

  filter = "";
  currentPage = 1;
  pageSize = 10;
  totalRows = 0;
  tableBusy = false;

  async created() {
    try {
      store.blockScreen = true;
      await this.loadData();
    } catch (e: unknown) {
      console.error(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async loadData(): Promise<any> {
    try {
      this.tableBusy = true;
      const response = await pcmService.getContasInativar();
      if (!response)
        return this.$toast.error("Erro ao obter a lista de contas");
      this.items = response;
      this.totalRows = response.length;
    } catch (e: unknown) {
      this.tratarError(e);
      this.items = [];
      this.totalRows = 0;
    } finally {
      this.tableBusy = false;
    }
  }

  async confirmarInativacao(conta: ContasInativar): Promise<void> {
    const etapa1 = await this.$bvModal.msgBoxConfirm(
      `Deseja inativar a conta ${conta.numeroContBancaria} (Banco: ${conta.codigoBanco} 
      / Agência: ${conta.codigoAgencia} / Descrição: ${conta.descricaoContBancaria})?`,
      {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Continuar",
        okVariant: "secondary",
        title: "Inativar conta",
      }
    );
    if (!etapa1) return;

    const etapa2 = await this.$bvModal.msgBoxConfirm(
      "Após a inativação a conta não poderá mais ser reativada. Confirma a inativação desta conta?",
      {
        buttonSize: "sm",
        cancelTitle: "Não",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar inativação",
        okVariant: "secondary",
        title: "Confirmação final",
      }
    );
    if (!etapa2) return;

    try {
      store.blockScreen = true;
      const payload = new ContasInativar({
        ...conta,
        CodigoBanco: conta.codigoBanco,
        CodigoAgencia: conta.codigoAgencia,
        NumeroContBancaria: conta.numeroContBancaria,
        TipoContBancaria: conta.tipoContBancaria,
        FlInativo: conta.flInativo === "N" ? "S" : "N",
      });
      await pcmService.patchContasInativar(payload);
      this.$toast.success("Operação realizada com sucesso.");
      await this.loadData();
    } catch (e: unknown) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  onFiltered(filteredItems: any): any {
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }
}
</script>
